<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>

        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </div>
      <br />

      <div style="height: 100vh">
        <vxe-table
          :loading="loadingTable"
          empty-text="Empty Data "
          keep-source
          border
          show-overflow
          show-header-overflow
          ref="xTable"
          height="100%"
          row-key
          highlight-hover-row
          highlight-current-row
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :data="contacts"
          :mouse-config="{ selected: true }"
          :checkbox-config="{
            highlight: true,
            range: true,
          }"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            showStatus: true,
          }"
          :scroll-y="{ mode: 'wheel' }"
          @checkbox-all="getDataSelected"
          @checkbox-change="getDataSelected"
        >
          <vxe-column type="seq" width="60"></vxe-column>

          <vxe-column
            width="150"
            field="kodeDepartment"
            header-align="center"
            align="left"
            title="KODE DEPARTMENT"
          >
          </vxe-column>
          <vxe-column
            width="250"
            field="namaDepartment"
            header-align="center"
            align="left"
            title="DEPARTMENT"
          >
          </vxe-column>

          <vxe-column
            width="100"
            field="status"
            header-align="center"
            align="center"
            title="SELECT"
          >
            <template #default="{ row }">
              <div>
                <vxe-button
                  size="mini"
                  type="button"
                  @click="selectDeptMethod(row)"
                  status="primary"
                  >Select</vxe-button
                >
              </div>
            </template>
          </vxe-column>

          <template v-for="(d, index) in tambahanColumn">
            <vxe-column
              sortable
              v-if="!d.edit"
              :key="index"
              :width="d.width"
              :field="d.field"
              header-align="center"
              :align="d.align"
              :title="d.title"
              :filters="[{ data: '' }]"
              :filter-method="$$filterMethod"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
          </template>
        </vxe-table>
      </div>
    </vx-card>

    <vxe-modal
      v-model="modalApprove"
      id="myModal6"
      width="800"
      height="80%"
      show-zoom
      show-footer
      resize
    >
      <template #title v-if="selectDept != null">
        <span>Approval Line Department {{ selectDept.namaDepartment }}</span>
      </template>
      <template #default>
        <el-row class="mb-5">
          <el-col>
            <h4>List Approval Line</h4>
            <vxe-table
              :loading="loadingTable"
              empty-text="Empty Data "
              keep-source
              border
              show-overflow
              show-header-overflow
              ref="tableApprovalline"
              height="200"
              row-key
              highlight-hover-row
              :row-style="rowStyle"
              highlight-current-row
              :row-config="{ isCurrent: true, isHover: true, height: 35 }"
              :column-config="{ resizable: true }"
              :data="dataApproval"
              :mouse-config="{ selected: true }"
              :checkbox-config="{
                highlight: true,
                range: true,
              }"
              :keyboard-config="{
                isArrow: true,
                isDel: true,
                isEnter: true,
                isTab: true,
                isEdit: true,
              }"
              :edit-config="{
                trigger: 'dblclick',
                mode: 'cell',
                showStatus: true,
              }"
              :filter-config="{
                iconNone: 'vxe-icon--funnel',
                iconMatch: 'vxe-icon--funnel',
              }"
              :scroll-y="{ mode: 'wheel' }"
            >
              <vxe-column type="seq" width="60"></vxe-column>

              <vxe-column
                width="180"
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                field="departmentKaryawan"
                header-align="center"
                align="left"
                title="DEPARTMENT"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="180"
                field="namaKaryawan"
                header-align="center"
                align="left"
                title="NAME"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="120"
                field="emailKaryawan"
                header-align="center"
                align="left"
                title="EMAIL"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>

              <vxe-column
                width="100"
                field="status"
                header-align="center"
                align="center"
                title="DELETE"
              >
                <template #default="{ row }">
                  <div>
                    <vxe-button
                      size="mini"
                      v-if="row.isDeleted != true"
                      type="button"
                      @click="deleteCheck(row)"
                      status="danger"
                      >Delete</vxe-button
                    >
                    <vxe-button
                      size="mini"
                      v-if="row.isDeleted == true"
                      type="button"
                      @click="undeleteCheck(row)"
                      status="warning"
                      >Undelete</vxe-button
                    >
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <h4>Select User For Approval Line</h4>
            <vxe-table
              :loading="loadingTable"
              empty-text="Empty Data "
              keep-source
              border
              show-overflow
              show-header-overflow
              ref="tableApprovallineSelect"
              height="250"
              row-key
              highlight-hover-row
              highlight-current-row
              :row-config="{ isCurrent: true, isHover: true, height: 35 }"
              :column-config="{ resizable: true }"
              :data="dataUser"
              :mouse-config="{ selected: true }"
              :checkbox-config="{
                highlight: true,
                range: true,
              }"
              :keyboard-config="{
                isArrow: true,
                isDel: true,
                isEnter: true,
                isTab: true,
                isEdit: true,
              }"
              :edit-config="{
                trigger: 'dblclick',
                mode: 'cell',
                showStatus: true,
              }"
              :scroll-y="{ mode: 'wheel' }"
            >
              <vxe-column type="seq" width="60"></vxe-column>

              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="100"
                field="kodeDepartment"
                header-align="center"
                align="left"
                title="KODE DEPARTMENT"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="180"
                field="department"
                header-align="center"
                align="left"
                title="DEPARTMENT"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="180"
                field="name"
                header-align="center"
                align="left"
                title="NAME"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
              <vxe-column
                :filters="[{ data: '' }]"
                :filter-method="$$filterMethod"
                width="120"
                field="email"
                header-align="center"
                align="left"
                title="EMAIL"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>

              <vxe-column
                width="100"
                field="status"
                header-align="center"
                align="center"
                title="SELECT"
              >
                <template #default="{ row }">
                  <div>
                    <vxe-button
                      size="mini"
                      type="button"
                      @click="selectApproval(row)"
                      status="primary"
                      >Select</vxe-button
                    >
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <vxe-button status="primary" @click="saveApprovalLine">Save</vxe-button>
        <vxe-button status="danger" @click="modalApprove = false"
          >Close</vxe-button
        >
      </template>
    </vxe-modal>
  </div>
</template>

<script>
// import contacts from './barang.json'
import moment from "moment";

const VxTour = () => import("@/components/VxTour.vue");
import axios from "axios";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    SweetModal,
    SweetModalTab,

    VxTour,
  },

  data() {
    return {
      tambahanColumn: [],
      dataApproval: [],
      dataUser: [],
      selectDept: null,
      modalApprove: false,
      tglAwal: new Date(),
      tglAkhir: new Date(),
      contacts: [],
      loadingTable: false,
      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    rowStyle({ row }) {
      if (row.isDeleted == true) {
        return {
          color: "#ffffff",
          backgroundColor: "#ff1717",
        };
      }
    },
    async saveApprovalLine() {
      this.loadingWait();
      console.log(this.dataApproval);
      console.log(this.selectDept);
      if (this.dataApproval.length > 0) {
        let post = await this.$api.post(
          "api/v1/hrd/approvalline/import",
          this.dataApproval
        );
      }
      this.notifikasiCustom("success", "Berhasil", "Menyimpan Data");
      this.modalApprove = false;
      this.dataApproval = [];
      this.getData();
      this.loadingStop();
    },
    selectApproval(row) {
      let cek = this.dataApproval.some((s) => s.emailKaryawan == row.email);

      if (cek) {
        this.notifikasiCustom(
          "warning",
          "Gagal",
          "Data Ini Sudah ada dalam approval line"
        );
        return;
      }
      let newElm = {
        kodeTipe: "lembur",
        department: this.selectDept.namaDepartment,
        kodeDepartment: this.selectDept.kodeDepartment,
        nomorKaryawan: row.nomorKaryawan,
        namaKaryawan: row.name,
        idKaryawan: row.idKaryawan,
        departmentKaryawan: row.department,
        emailKaryawan: row.email,
        usernameKaryawan: row.username,
        isDeleted: false,
      };
      this.dataApproval.push(newElm);
    },
    deleteCheck(row) {
      row.isDeleted = true;
    },
    undeleteCheck(row) {
      row.isDeleted = false;
    },
    async selectDeptMethod(row) {
      this.modalApprove = true;
      this.selectDept = row;
      let get = await this.$api.get("api/v1/hrd/approvalline/getbyspesifik", {
        params: {
          kodeTipe: "lembur",
          department: this.selectDept.kodeDepartment,
        },
      });
      this.dataApproval = get.data.content;
    },
    approved() {},
    formatWaktu({ cellValue }) {
      return this.$formatDatemoment(cellValue);
    },
    getDataSelected({}) {},
    cekTanggal() {
      this.getData();
    },
    async getData() {
      // let start = moment(new Date(this.tglAwal)).format("yyyy-MM-DD");
      let get = await this.$api.get(
        "api/v1/hrd/masterdata/department/getapproval"
      );
      let getUser = await this.$api.get("api/v1/user/list", {
        params: {
          pageLimit: 1000000,
        },
      });
      this.dataUser = getUser.data.content;
      let totalAddCol = 0;
      this.contacts = get.data.content.map((m) => {
        m.listApproval = m.listApproval.filter((f) => f.kodeTipe == "lembur");
        if (m.listApproval.length >= totalAddCol) {
          totalAddCol = m.listApproval.length;
        }
        let i = 1;
        for (let elm of m.listApproval) {
          m["approval" + i] = elm.emailKaryawan;
          i += 1;
        }

        return m;
      });

      this.tambahanColumn = [];
      for (let i = 1; i <= totalAddCol; i++) {
        this.tambahanColumn.push({
          title: "APPROVAL " + i,
          field: "approval" + i,
          align: "left",
          width: "150",
        });
      }

      console.log(this.contacts);
    },
  },

  async mounted() {
    this.getData();
    // this.getDataTime();

    // let get = await this.$api.post(
    //   "api/v1/hrd/jadwal/listjadwal/saveall?tglAwal=2022-02-01&tglAkhir=2022-02-28",
    //   []
    // );
  },
};
</script>
